/* eslint-ignore */
// @ts-nocheck
import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
  color: #202020;
`;

export const WrapperList = styled.div`
  display: flex;
  align-items: center;
  ${(props) =>
    props.isLoading &&
    css`
      opacity: 0.6;
    `}
`;

export const Dots = styled.div``;

export const ControlButton = styled.button`
  font-size: 24px;
  color: #656565;
  cursor: pointer;
  border: none;
  background-color: transparent;
`;

export const PageButton = styled.button`
  border: none;
  background-color: transparent;
  color: #0018FF
  &:hover {
    text-decoration: underline;
  }

  ${({ active }) =>
    active &&
    css`
      font-weight: 600;
    `}
`;
